// Enrichment types / categories

export const ENRICHMENT_CATEGORY_TYPE_PROFILE = 1;
export const ENRICHMENT_CATEGORY_TYPE_VOTE = 2;
export const ENRICHMENT_CATEGORY_TYPE_QUESTIONAIRE = 3;
export const ENRICHMENT_CATEGORY_TYPE_CUSTOM = 4;
export const ENRICHMENT_CATEGORY_TYPE_LIVEVOTING = 5;
export const ENRICHMENT_CATEGORY_TYPE_WORKSHOPS = 6;
